(function () {
  'use strict';

  function syncStickyPrice() {
    // The active bundle option's price (confirmed from your inspector)
    const activeOption = document.querySelector(
      '.moonbundle-option-active .moonbundle-option-single-price'
    );

    if (!activeOption) return;

    const priceText = activeOption.textContent.trim();
    if (!priceText) return;

    // The sticky bar price (confirmed: span.price inside .price__regular)
    const stickyPrice = document.querySelector(
      '.sticky-add-to-cart__price .price__regular .price'
    );

    if (!stickyPrice) return;

    stickyPrice.textContent = priceText;
  }

  function initMoonBundleSync() {
    const moonBundle =
      document.querySelector('moonbundle-component') ||
      document.querySelector('.moonbundle-options-horizontal');

    if (!moonBundle) {
      setTimeout(initMoonBundleSync, 500);
      return;
    }

    // Run once on load
    syncStickyPrice();

    // Watch for class changes (moonbundle-option-active toggling)
    const observer = new MutationObserver(function () {
      syncStickyPrice();
    });

    observer.observe(moonBundle, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    // Fallback: direct click listener on each option
    document.querySelectorAll('.moonbundle-option-wrapper').forEach(function (el) {
      el.addEventListener('click', function () {
        setTimeout(syncStickyPrice, 150);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMoonBundleSync);
  } else {
    initMoonBundleSync();
  }
})();